import * as React from "react";

interface IComponentProps {
	title: string;
	body: string;
}

type Props = IComponentProps;

class BranchLocationDetailsTile extends React.Component<Props> {

	render() {
		const {title, body} = this.props;
		return (
			<div className="tile-wrapper">
				<p className="title">{title}</p>
				<p className="body">{body}</p>
			</div>
		);
	}

}

export default BranchLocationDetailsTile;